import React from 'react';

export const Riff = () => {
    return (
        <h2>This is a riff</h2>
    )
}